import {ParcelDependencyContainer} from "./core/ParcelDependencyContainer";
import {Router} from "./router";
import {UrlSanitizer} from "./shared/UrlSanitizer";

export class DependencyContainerFactory {
    static container: ParcelDependencyContainer;

    public static create(router: Router) {
        if (!this.container) {
            this.container = new ParcelDependencyContainer();
            this.register(router);
        }

        return this.container;
    }

    private static register(router: Router) {

        this.container.register('UrlSanitizer', ()=>{
            return new UrlSanitizer(); 
        });

    }

}
